import { render, staticRenderFns } from "./GivenAccess.vue?vue&type=template&id=24b8f69e&scoped=true&"
import script from "./GivenAccess.vue?vue&type=script&lang=js&"
export * from "./GivenAccess.vue?vue&type=script&lang=js&"
import style0 from "./GivenAccess.vue?vue&type=style&index=0&id=24b8f69e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b8f69e",
  null
  
)

export default component.exports